export default __webpack_public_path__ + "static/media/varunada_lazurite_fragment.edd7b9ae.png";